import { Injector } from '@angular/core';

let _appInjector: Injector | null = null;

export function setAppInjector(injector: Injector) {
  _appInjector = injector;
}

export function getAppInjector(): Injector {
  if (!_appInjector) throw new Error('AppInjector no inicializado aún');
  return _appInjector;
}
